import { useState, type FormEvent } from "react";
import { Download, KeyRound, Trash2 } from "lucide-react";
import { accountApi, consumerActivityLabels, type ConsumerMe } from "../../account";

export function PasswordForm() {
  const [open, setOpen] = useState(false),
    [message, setMessage] = useState("");
  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setMessage("");
    const data = new FormData(event.currentTarget);
    try {
      await accountApi("/api/account/password", {
        method: "POST",
        body: JSON.stringify({
          currentPassword: data.get("currentPassword"),
          newPassword: data.get("newPassword"),
        }),
      });
      window.location.assign("/kirjaudu");
    } catch (cause) {
      setMessage(
        cause instanceof Error ? cause.message : "Salasanaa ei voitu vaihtaa.",
      );
    }
  };
  if (!open)
    return (
      <button className="secondary-action" onClick={() => setOpen(true)}>
        <KeyRound size={17} /> Vaihda salasana
      </button>
    );
  return (
    <form className="inline-account-form narrow" onSubmit={submit}>
      <label>
        Nykyinen salasana
        <input
          name="currentPassword"
          type="password"
          autoComplete="current-password"
          required
        />
      </label>
      <label>
        Uusi salasana
        <input
          name="newPassword"
          type="password"
          autoComplete="new-password"
          minLength={12}
          required
        />
      </label>
      {message && <p className="account-error">{message}</p>}
      <div>
        <button
          type="button"
          className="text-action"
          onClick={() => setOpen(false)}
        >
          Peruuta
        </button>
        <button>Vaihda ja kirjaa ulos</button>
      </div>
    </form>
  );
}


export function ConsumerPreferences({ profile, onChanged }: { profile: ConsumerMe["profile"]; onChanged: () => void }) {
  const [message, setMessage] = useState(""),[resultEnabled,setResultEnabled]=useState(profile.resultRemindersEnabled);
  const save = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault(); setMessage("Tallennetaan…"); const data = new FormData(event.currentTarget);
    try { await accountApi("/api/account/preferences", { method: "PATCH", body: JSON.stringify({ defaultActivity: data.get("defaultActivity"), defaultRodCount: Number(data.get("defaultRodCount")), reminderDaysBefore: Number(data.get("reminderDaysBefore")),resultRemindersEnabled:data.get("resultRemindersEnabled")==="on",resultReminderHour:Number(data.get("resultReminderHour")) }) }); setMessage("Asetukset tallennettiin."); onChanged(); }
    catch (error) { setMessage(error instanceof Error ? error.message : "Asetuksia ei voitu tallentaa."); }
  };
  return <form className="consumer-preferences-form" onSubmit={save}><label>Oletuskalastustapa<select name="defaultActivity" defaultValue={profile.defaultActivity}>{Object.entries(consumerActivityLabels).map(([value, label]) => <option value={value} key={value}>{label}</option>)}</select></label><label>Oletusvapamäärä<input name="defaultRodCount" type="number" min="1" max="20" defaultValue={profile.defaultRodCount}/></label><label>Muistuta ennen reissua tai luvan päättymistä<select name="reminderDaysBefore" defaultValue={profile.reminderDaysBefore}>{[0,1,3,7,14,30].map((value) => <option value={value} key={value}>{value === 0 ? "Ei ennakkomuistutusta" : `${value} päivää ennen`}</option>)}</select></label><fieldset className="consumer-result-reminder-settings"><legend>Reissun jälkikirjaus</legend><label className="consumer-setting-toggle"><input name="resultRemindersEnabled" type="checkbox" checked={resultEnabled} onChange={event=>setResultEnabled(event.target.checked)}/><span><b>Muistuta päättyneen reissun tuloksesta</b><small>Muistutus näkyy vain omalla tililläsi ja voidaan siirtää tai ohittaa.</small></span></label><label>Muistutusaika seuraavana päivänä<select name="resultReminderHour" defaultValue={profile.resultReminderHour}>{[7,9,12,18,21].map(value=><option value={value} key={value}>klo {String(value).padStart(2,"0")}:00</option>)}</select><small>{resultEnabled?"Muistutus luodaan tämän kellonajan jälkeen.":"Kellonaika säilyy valmiina, jos otat muistutukset myöhemmin käyttöön."}</small></label></fieldset>{message && <p>{message}</p>}<button>Tallenna asetukset</button></form>;
}

export function FishingHistoryControls(){const[open,setOpen]=useState(false),[message,setMessage]=useState(""),[busy,setBusy]=useState(false);const remove=async(event:FormEvent<HTMLFormElement>)=>{event.preventDefault();setBusy(true);setMessage("");const data=new FormData(event.currentTarget);try{const value=await accountApi<{deletedTrips:number;deletedImages:number;boundary:string}>("/api/account/fishing-history",{method:"DELETE",body:JSON.stringify({confirmation:data.get("confirmation"),currentPassword:data.get("currentPassword")})});setMessage(`${value.deletedTrips} reissua ja ${value.deletedImages} yksityistä kuvaa poistettiin. ${value.boundary}`);setOpen(false);}catch(error){setMessage(error instanceof Error?error.message:"Kalastushistoriaa ei voitu poistaa.");}finally{setBusy(false);}};return <section className="fishing-data-controls"><header><div><b>Omat kalastustiedot</b><p>Lataa omat reissut ja saaliit tai tyhjennä vain kalastushistoria. Käyttäjätili, tallennetut paikat, Kalapakki, luvat ja tilaukset säilyvät.</p></div><Download/></header><div className="fishing-data-downloads"><a href="/api/account/fishing-history?format=json" download><Download/>Lataa JSON</a><a href="/api/account/fishing-history?format=csv" download><Download/>Lataa CSV</a></div>{message&&<p className="form-message" role="status">{message}</p>}{open?<form onSubmit={event=>void remove(event)}><p><Trash2/>Poisto on pysyvä. Vie tiedot ensin talteen, jos haluat säilyttää ne.</p><label>Kirjoita POISTA HISTORIA<input name="confirmation" required pattern="POISTA HISTORIA" autoComplete="off"/></label><label>Nykyinen salasana<input name="currentPassword" type="password" required autoComplete="current-password"/></label><div><button type="button" onClick={()=>setOpen(false)}>Peruuta</button><button className="danger" disabled={busy}>{busy?"Poistetaan…":"Poista kalastushistoria"}</button></div></form>:<button className="fishing-data-delete" type="button" onClick={()=>setOpen(true)}><Trash2/>Tyhjennä kalastushistoria</button>}</section>;}
